import notification from "./notification";

const setAuthorization = (
  closeModalAfterAuthentication,
  login,
  response,
  setErrors,
  type
) => {
  if (response.status === 200) {
    for (var pair of response.headers.entries()) {
      if (pair[0] === "authorization") {
        const token = pair[1].substring(7);
        localStorage.setItem("user", token);
      }
    }
    response.json().then((response) => {
      const name = response.data.attributes.username;
      const avatar = response.data.attributes.avatar;
      login(name, avatar);
      closeModalAfterAuthentication();
    });

    if (type === "login") {
      notification("Login successful!", "success", 3000);
    } else {
      notification("Signup successful!", "success", 3000);
    }
  } else {
    response.json().then((data) => {
      setErrors(data);
    });
  }
};

export default setAuthorization;
